import { doodModalConfig } from './dood-modal-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const COMOLINKACCOUNTMODAL_LEGACY_FIELD_ORDER = [
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  comoLinkAccountModalDescriptor: _generatedComoLinkAccountModalDescriptor,
  comoLinkAccountModalModalDefinition,
  comoLinkAccountModalDashboardLayout,
  comoLinkAccountModalConfig,
  comoLinkAccountModalResolveConfig,
  comoLinkAccountModalProperties,
} = doodModalConfig(
  {
    name: "Como - Link account modal",
    handle: "como-link-account-modal",
    internal_name: "ComoLinkAccountModal",
    componentType: 'ComoLinkAccountModalComponent',
    category: 'modal',
    description: "Como - Link account modal.",
    keywords: [],
    isContentModal: true,
    defaultHandle: "como-link-account-modal",
    allowed_in: ["ModalBlock"],
    sharedFields: {}
  },

  () => ({
    // no scalar props
  }),

  () => ({
    tabs: [
      {
        label: 'Design',
        fieldsets: [
          {
            legend: 'Properties',
            fields: [],
          },
        ],
      },
    ],
  })
);

export function comoLinkAccountModalDescriptor(): IBlockDescriptor;
export function comoLinkAccountModalDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function comoLinkAccountModalDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedComoLinkAccountModalDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedComoLinkAccountModalDescriptor, comoLinkAccountModalProperties, fieldOrder);
}

export {
  comoLinkAccountModalModalDefinition,
  comoLinkAccountModalDashboardLayout,
  comoLinkAccountModalProperties,
  comoLinkAccountModalConfig,
  comoLinkAccountModalResolveConfig,
};

export type ComoLinkAccountModalConfig = typeof comoLinkAccountModalConfig;
